(() => {
  const OPEN_BTN_SELECTOR = '[data-open-rewards]';
  const IGNORE_SELECTOR = '.tp-rewards-box, .tp-rewards-btn, [data-open-rewards]';

  const isVisible = (el) => {
    const st = getComputedStyle(el);
    if (st.display === 'none' || st.visibility === 'hidden') return false;
    if (Number(st.opacity) === 0) return false;
    return true;
  };

  const hasFixedAncestor = (el) => {
    let cur = el;
    let depth = 0;
    while (cur && cur !== document.documentElement && depth < 25) {
      const pos = getComputedStyle(cur).position;
      if (pos === 'fixed') return true;
      cur = cur.parentElement;
      depth++;
    }
    return false;
  };

  const isNearBR = (r) => {
    const dx = window.innerWidth - r.right;
    const dy = window.innerHeight - r.bottom;
    // 放寬範圍到 600，避免你右下角按鈕不在最角落
    return dx > -10 && dy > -10 && dx < 600 && dy < 600;
  };

  const zIndexOf = (el) => {
    const z = getComputedStyle(el).zIndex;
    const n = Number(z);
    return Number.isFinite(n) ? n : 0;
  };

  function score(el) {
    if (!el || !(el instanceof Element)) return -1;
    if (el.matches(IGNORE_SELECTOR) || el.closest(IGNORE_SELECTOR)) return -1;
    if (!isVisible(el)) return -1;

    const r = el.getBoundingClientRect();
    if (r.width < 26 || r.height < 26) return -1;
    if (!isNearBR(r)) return -1;

    // 必須在 fixed 區塊裡（按鈕常是 absolute，但外層 fixed）
    if (!hasFixedAncestor(el) && getComputedStyle(el).position !== 'fixed') return -1;

    const idcls = ((el.id || '') + ' ' + (el.className || '')).toLowerCase();
    const label = (el.getAttribute('aria-label') || '').toLowerCase();
    const txt = ((el.innerText || '') + ' ' + label).toLowerCase();

    // 排除聊天/常見浮動工具
    if (/(chat|intercom|crisp|zendesk|tawk|messenger|fb|line|whatsapp)/.test(idcls + ' ' + txt)) return -1;

    let s = 0;

    // 越靠右下越高分
    const dist = Math.hypot(window.innerWidth - r.right, window.innerHeight - r.bottom);
    s += Math.max(0, 600 - dist);

    // Growave/refrr 特徵強加分（你之前看到的是 growave_critical_* script，這類字會出現在 class/id）
    if (/growave|refrr|reward|loyal|point|vip/.test(idcls + ' ' + txt)) s += 900;

    // 「會員」常出現在浮動按鈕
    if ((el.innerText || '').includes('會員') || /會員/.test(label)) s += 260;

    // 有 svg/img icon 加分
    if (el.querySelector && el.querySelector('svg, img')) s += 80;

    // z-index 越高越像浮動入口
    s += Math.min(400, zIndexOf(el) / 8);

    // 可點特徵
    const st = getComputedStyle(el);
    if (st.cursor === 'pointer') s += 90;
    if (el.matches('button,a,[role="button"],[onclick]')) s += 160;

    // 尺寸像浮動按鈕（太大可能是容器）
    if (r.width <= 360 && r.height <= 180) s += 80;

    return s;
  }

  function pickLauncher() {
    const els = Array.from(document.querySelectorAll('body *'));
    let best = null;
    let bestScore = -1;

    for (const el of els) {
      const sc = score(el);
      if (sc > bestScore) {
        bestScore = sc;
        best = el;
      }
    }

    if (bestScore < 260) return null;

    // 優先點可互動祖先
    const clickable = best.closest?.('button,a,[role="button"],[onclick]') || best;
    return clickable;
  }

  function isPanelOpen() {
    // 簡單判斷：右側大面板（fixed 且很大）
    const all = document.querySelectorAll('body *');
    for (const el of all) {
      const st = getComputedStyle(el);
      if (st.position !== 'fixed') continue;
      if (!isVisible(el)) continue;
      const r = el.getBoundingClientRect();
      if (r.width > 260 && r.height > 260 && r.right >= window.innerWidth - 2) return true;
    }
    return false;
  }

  async function openRewards() {
    if (isPanelOpen()) return true;

    const launcher = pickLauncher();
    if (!launcher) return false;

    console.log('[TP] launcher picked:', launcher);
    launcher.click();

    await new Promise(r => setTimeout(r, 300));
    if (isPanelOpen()) return true;

    await new Promise(r => setTimeout(r, 900));
    return isPanelOpen();
  }

  window.TP_openRewards = openRewards;

  window.TP_debugCorner = () => {
    const els = Array.from(document.querySelectorAll('body *'));
    const scored = els
      .map(el => ({ el, sc: score(el) }))
      .filter(x => x.sc > 0)
      .sort((a, b) => b.sc - a.sc)
      .slice(0, 15);

    console.table(scored.map(x => {
      const r = x.el.getBoundingClientRect();
      return {
        score: x.sc,
        tag: x.el.tagName.toLowerCase(),
        id: x.el.id,
        class: (x.el.className || '').toString().slice(0, 80),
        text: (x.el.innerText || '').trim().slice(0, 20),
        w: Math.round(r.width),
        h: Math.round(r.height),
        dx: Math.round(window.innerWidth - r.right),
        dy: Math.round(window.innerHeight - r.bottom),
        z: getComputedStyle(x.el).zIndex
      };
    }));

    return scored.map(x => x.el);
  };

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(OPEN_BTN_SELECTOR);
    if (!btn) return;

    e.preventDefault();
    const ok = await openRewards();
    if (!ok) {
      alert('仍然抓不到 Growave 浮動按鈕。\n請在 Console 跑 TP_debugCorner()，把 table 截圖貼我，我就能把它鎖成 100% 命中。');
    }
  }, true);
})();
(() => {
  const lock = (on) => {
    document.documentElement.classList.toggle('tp-lock-scroll', !!on);
  };

  const openBox = (box) => {
    if (!box) return;
    box.classList.add('tp-rewards-open');
    const drawer = box.querySelector('.tp-rewards-drawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    lock(true);
  };

  const closeBox = (box) => {
    if (!box) return;
    box.classList.remove('tp-rewards-open');
    const drawer = box.querySelector('.tp-rewards-drawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    lock(false);
  };

  // ✅ 事件委派：不怕 cart section 被重繪
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-tp-open-rewards]');
    if (openBtn) {
      openBox(openBtn.closest('.tp-rewards-box'));
      return;
    }

    const closeBtn = e.target.closest('[data-tp-close-rewards]');
    if (closeBtn) {
      closeBox(closeBtn.closest('.tp-rewards-box'));
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.tp-rewards-box.tp-rewards-open').forEach(closeBox);
  });
})();